import { AISearchResultGqlSchema } from "./AISearchResult";
import { articleGQLSchema } from "./Article";

export const AISearchResponseGqlSchema = `
  articles{
    ${articleGQLSchema}
  }
  searchResults{
    ${AISearchResultGqlSchema}
  }
`;
